module.exports = __webpack_public_path__ + "img/ben-meet.f8b813ee.jpg";